import { SubscriberLevel, SubscriptionStatus } from "../lib/definitions";
import useAuth, { subscriptionDescription, subscriptionRenewalDate } from "../lib/useAuth";
import { dateString } from "./Localization";

export default function AccountDescription()
{


    function refresh()
    {
        window.location.reload();
    }
    const {userInformation} = useAuth();

    let sub = <>You do not currently have a subscription</>;
    let expDate = <></>
    let renewal = <></>

    if (userInformation?.subscribed)
    {
        sub = <>You have a{(userInformation.subscriber_level==SubscriberLevel.image?'n':'')} <b>{subscriptionDescription(userInformation)}</b> subscription.</>
        let x = subscriptionRenewalDate(userInformation);
        
        expDate = <>{dateString(x)}</>

        if (userInformation.status == SubscriptionStatus.pendingCancellation)
        {
            renewal = <>You have cancelled your subscription, but you can still access it until <b>{expDate}</b></>
        }
        else
        {
        renewal  = <>It will renew on <b>{expDate}</b></>
        }

        if (userInformation?.is_fixed_term)
        {
            renewal = <>It is fixed term, and will expire on <b>{expDate}</b></>
        }
    }

    return <>
    {(userInformation?.userName?<>You are logged on as <b>{userInformation?.userName}</b></>:<>You do not currently have a username</>)}. {sub} {renewal}. If you&rsquo;ve just subscribed, upgraded or cancelled, please check back in a minute or two and <a href='#' onClick={refresh}>refresh</a> this page</>
}
